import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

/**
 * ProductBadge - Ürün kartlarında görünecek dinamik rozet bileşeni
 * @param {string|string[]} badgeType - Tek rozet tipi (string) veya çoklu rozet tipleri (array): 'none', 'new', 'popular', 'chef_special', 'service_fee', 'serves_two'
 */
const ProductBadge = ({ badgeType }) => {
    const { language } = useLanguage();

    // Badge type'ı array'e çevir (tek badge için de çalışsın)
    const badgeTypes = Array.isArray(badgeType) ? badgeType : [badgeType];
    
    // Geçerli badge'leri filtrele
    const validBadges = badgeTypes.filter(type => type && type !== 'none');
    
    // Rozet yoksa hiçbir şey render etme
    if (validBadges.length === 0) {
        return null;
    }

    // Rozet konfigürasyonları (Tema uyumlu Tailwind sınıfları)
    const badgeConfig = {
        new: {
            text: { tr: 'YENİ', en: 'NEW' },
            className: 'bg-green-100/80 text-green-800 dark:bg-green-600/90 dark:text-white'
        },
        popular: {
            text: { tr: 'POPÜLER', en: 'POPULAR' },
            className: 'bg-blue-100/80 text-blue-800 dark:bg-blue-600/90 dark:text-white'
        },
        chef_special: {
            text: { tr: 'ŞEFİN TAVSİYESİ', en: "CHEF'S SPECIAL" },
            className: 'bg-amber-100/80 text-amber-800 dark:bg-amber-600/90 dark:text-white'
        },
        service_fee: {
            text: { tr: 'EKSTRA SERVİS ÜCRETİ +100₺', en: 'EXTRA SERVICE FEE +100₺' },
            className: 'bg-red-100/80 text-red-800 dark:bg-red-600/90 dark:text-white'
        },
        serves_two: {
            text: { tr: 'İKİ KİŞİLİK SERVİS EDİLİR', en: 'SERVES TWO PEOPLE' },
            className: 'bg-purple-100/80 text-purple-800 dark:bg-purple-600/90 dark:text-white'
        }
    };

    return (
        <div className="flex flex-wrap gap-2 mt-2">
            {validBadges.map((type, index) => {
                const config = badgeConfig[type];
                
                if (!config) {
                    return null;
                }

                return (
                    <div
                        key={`${type}-${index}`}
                        className={`inline-block backdrop-blur-md px-3 py-1 text-xs font-bold uppercase tracking-wider rounded-full shadow-lg ${config.className}`}
                        style={{
                            borderRadius: '12px' // Fiyat kutucuğuyla uyumlu border-radius
                        }}
                    >
                        {config.text[language]}
                    </div>
                );
            })}
        </div>
    );
};

export default ProductBadge;
